module.exports = __webpack_public_path__ + "static/media/Diamond-green.99e2cae4.svg";